import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-seeker-request-add-template',
  templateUrl: './seeker-request-add-template.component.html',
  styleUrls: ['./seeker-request-add-template.component.scss'],
})
export class SeekerRequestAddTemplateComponent implements OnInit {

  constructor(
    private popCtrl : ModalController,
  ) { }

  title="";
  disabled = true;

  ngOnInit() {}


  UpdateTitle(){
    if(this.title){
       this.disabled = false;
    }else{
      this.disabled = true;

    }
  }


  async dismiss(option:any) {
    
    let data ={
      option: option,
      title : this.title,
    }
    
    await this.popCtrl.dismiss(data);
  }

}
